import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';   
import { warehouseList } from '../../services/Api';

export const fetchWarehouses = createAsyncThunk(
    'warehouse/fetchWarehouses',
    async (_, { getState }) => {
        try {
            const { filters } = getState().warehouse;
            const params = {
                sort: 'id',
                sort_order: 'desc',
                page: filters.page,
                paginate_per_page: filters.paginate_per_page,
                ...(filters.search && { name: filters.search }),
                ...(filters.from && { from: filters.from }),
                ...(filters.to && { to: filters.to }),
                ...(filters.status && { status: filters.status }),
            };

            const response = await warehouseList(params);
            return response;
        } catch (error) {
            throw error;
        }
    }
);

// const initialState = {
//     warehouses: [],
//     loading: false,
//     error: null,
//     shouldRefresh: false,
//     pagination: {
//         currentPage: 1,
//         totalPage: 1,
//         showing: 10,
//         total: 0
//     },
//     filters: {
//         search: '',
//         from: '',
//         to: '',
//         status: '',
//         page: "1",
//         paginate_per_page: "10"
//     }
// };

const warehouseSlice = createSlice({
    name: 'warehouse',
    initialState: {
        warehouses: [],
        loading: false,
        error: null,
        filters: {
            from: '',
            to: '',
            status: '',
            page: '1',
            paginate_per_page: '10',
            sort: 'id',
            sort_order: 'desc'
        },
        pagination: {},
    },
    reducers: {
        setShouldRefresh: (state, action) => {
            state.shouldRefresh = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                from: '',
                to: '',
                status: '',
                page: '1',
                paginate_per_page: '10',
                sort: 'id',
                sort_order: 'desc'
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWarehouses.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchWarehouses.fulfilled, (state, action) => {
                state.loading = false;
                state.warehouses = action.payload.data || [];
                state.pagination = action.payload.pagination;
                if (action.payload.meta) {
                    state.pagination = {
                        currentPage: action.payload.meta.current_page || 1,
                        totalPage: action.payload.meta.last_page || 1,
                        showing: action.payload.meta.per_page || 10,
                        total: action.payload.meta.total || 0
                    };
                }
            })
            .addCase(fetchWarehouses.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { setFilters, resetFilters, setShouldRefresh } = warehouseSlice.actions;
export default warehouseSlice.reducer;